<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    fill="none"
    version="1.1"
    width="16"
    height="16"
    viewBox="0 0 16 16"
  >
    <g style="mix-blend-mode: passthrough">
      <g style="mix-blend-mode: passthrough">
        <path
          d="M16,1.9900000095367432C16,1.9900000095367432,0,7.990000009536743,0,7.990000009536743C0,7.990000009536743,16,13.990000009536743,16,13.990000009536743C16,13.990000009536743,12,7.990000009536743,12,7.990000009536743C12,7.990000009536743,16,1.9900000095367432,16,1.9900000095367432C16,1.9900000095367432,16,1.9900000095367432,16,1.9900000095367432Z"
          fill-rule="evenodd"
          fill="currentColor"
        />
      </g>
    </g>
  </svg>
</template>
<script lang="ts">
import type { DefineComponent } from 'vue'
export default {
  name: 'DirectionLeft',
} as DefineComponent
</script>
